module.exports = __webpack_public_path__ + "img/lh-logo.a7ca5db0.svg";